import React, { useRef } from 'react';
import { Box, Button, Card, CardActionArea, CardActions, CardContent, CardHeader, Divider, Stack } from '@mui/material';
import { LuCalendarClock } from "react-icons/lu";
import { RiDeleteBin2Line } from "react-icons/ri";
import { RemitterCardGrid, RestitutionCardGrid } from './RestitutionBoxes';

export const RestitutionCards = (props) => {
    const {
        mode,
        setUpdateRemitter,
        setUpdateRestitution,
        ts,
        updateRemitter,
        updateRestitution,
        state,
        handleFieldChange,
        handleTotalRestitutionFocus,
        handleMonthlyPaymentFocus,
        HandleUpdateRestitutionCards,
        paymentPlanModal,
        setPaymentPlanModal,
        setDeleteRestitutionModal
    } = props;

    const totalRestitutionRef = useRef(null);
    const monthlyPaymentRef = useRef(null);

    function handleDeleteClick() {
        setDeleteRestitutionModal(true);
    }


    const RestitutionCardButtons = () => {

        return (
            !updateRestitution
                ?
                <Stack direction='row' spacing={1.5} sx={{ marginLeft: 'auto' }}>
                    {/*<Button*/}
                    {/*    variant="contained"*/}
                    {/*    sx={{*/}
                    {/*        m: '.5vh',*/}
                    {/*        mt: '0',*/}
                    {/*        backgroundColor: mode === 'dark' ? '#50C878' : '#52c176',*/}
                    {/*        color: 'white',*/}
                    {/*        marginLeft: 'auto'*/}
                    {/*    }}*/}
                    {/*    onClick={() => setPaymentPlanModal(!paymentPlanModal)}*/}
                    {/*    startIcon={<LuCalendarClock fontSize="x-large" /> }*/}
                    {/*>*/}
                    {/*    Create Payment Plan*/}
                    {/*</Button>*/}
                    <Button
                        variant="contained"
                        sx={{
                            m: '.5vh',
                            mt: '0',
                            backgroundColor: 'steelblue',
                            color: 'white',
                            marginLeft: 'auto'
                        }}
                        onClick={() => setUpdateRestitution(true)}
                    >
                        Update Restitution Details
                    </Button>
                </Stack>
                :
                <Box marginLeft="auto">
                    <Button variant="contained" sx={{ m: '.5vh', mt: '0', backgroundColor: '#ae0e0e', color: 'white' }} startIcon={<RiDeleteBin2Line />} onClick={handleDeleteClick}>DELETE</Button>
                    <Button variant="contained" sx={{ m: '.5vh', mt: '0', backgroundColor: 'steelblue', color: 'white' }} onClick={async () => await HandleUpdateRestitutionCards('restitution')}>Save</Button>
                    <Button variant="contained" sx={{ m: '.5vh', mt: '0', backgroundColor: 'steelblue', color: 'white' }} onClick={() => setUpdateRestitution(false)}>Cancel</Button>
                </Box>
        );
    }
    const RemitterCardButtons = () => {

        return (
            !updateRemitter
                ? <Button
                    variant="contained"
                    sx={{
                        m: '.5vh',
                        mt: '0',
                        backgroundColor: 'steelblue',
                        color: 'white',
                        marginLeft: 'auto'
                    }}
                    onClick={() => setUpdateRemitter(true)}
                >
                    Update Remitter Information
                </Button>
                :
                <Box marginLeft="auto">
                    <Button variant="contained" sx={{ m: '.5vh', mt: '0', backgroundColor: 'steelblue', color: 'white' }} onClick={async () => await HandleUpdateRestitutionCards('remitter')}>Save</Button>
                    <Button variant="contained" sx={{ m: '.5vh', mt: '0', backgroundColor: 'steelblue', color: 'white' }} onClick={() => setUpdateRemitter(false)}>Cancel</Button>
                </Box>

        );
    }

    const sx =
    {
        height: '100%',
        transition: 'background-color 0.2s ease-in-out',
        '&[data-active]': {
            backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)',
            '&:hover': {
                backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)',
            },
            '&.Mui-focusVisible': {
                backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)', // Disable focus effect
            },
            '&.Mui-focusHighlight': {
                backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)'
            }
        },
        '&:hover': {
            backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)'
        },
        '&.Mui-focusVisible': {
            backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)', // Disable focus effect
        },
        '&.Mui-focusHighlight': {
            backgroundColor: mode === 'dark' ? '#212121' : 'rgb(255, 255, 255)'
        },
    }


    return (
        <Stack direction="row" spacing={0} divider={<Divider orientation="vertical" flexItem />}>
            <Card
                sx={
                    {
                        background: "inherit",
                        width: 'auto',
                    }
                }
            >
                {
                    updateRestitution ?
                        <CardActionArea
                            disableRipple
                            data-active={updateRestitution ? '' : undefined}
                            sx={
                                {
                                    ...sx
                                }
                            }
                            focusVisibleClassName=""
                            focusHighlightClassName=""
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <CardHeader
                                title="Update Restitution Details"
                                subheader="Conditions Set For Restitution"
                            />
                            <CardContent
                                width="auto"
                            >
                                <RestitutionCardGrid
                                    handleFieldChange={handleFieldChange}
                                    state={state}
                                    updateRestitution={updateRestitution}
                                    totalRestitutionRef={totalRestitutionRef}
                                    handleTotalRestitutionFocus={handleTotalRestitutionFocus}
                                    monthlyPaymentRef={monthlyPaymentRef}
                                    handleMonthlyPaymentFocus={handleMonthlyPaymentFocus}
                                    ts={ts}
                                />
                            </CardContent>
                            <CardActions>
                                <RestitutionCardButtons
                                />
                            </CardActions>
                        </CardActionArea>
                        :
                        <>
                            <CardHeader
                                title="Restitution Details"
                                subheader="Conditions Set For Restitution"
                            />
                            <CardContent
                                width="auto">
                                <RestitutionCardGrid
                                    handleFieldChange={handleFieldChange}
                                    state={state}
                                    updateRestitution={updateRestitution}
                                    totalRestitutionRef={totalRestitutionRef}
                                    handleTotalRestitutionFocus={handleTotalRestitutionFocus}
                                    monthlyPaymentRef={monthlyPaymentRef}
                                    handleMonthlyPaymentFocus={handleMonthlyPaymentFocus}
                                    ts={ts}
                                />
                            </CardContent>
                            <CardActions>
                                <RestitutionCardButtons />
                            </CardActions>
                        </>
                }
            </Card>
            <Card sx={{ background: "inherit", width: 'auto' }}>
                {
                    updateRemitter
                        ?
                        <CardActionArea
                            disableRipple
                            data-active={updateRemitter ? '' : undefined}
                            sx={
                                {
                                    ...sx
                                }
                            }
                            focusVisibleClassName=""
                            focusHighlightClassName=""
                            onMouseDown={(e) => e.stopPropagation()}
                        >
                            <CardHeader title="update Remitter Information" subheader="Information related to plaintiff" />
                            <CardContent width="auto">
                                <RemitterCardGrid
                                    handleFieldChange={handleFieldChange}
                                    state={state}
                                    updateRemitter={updateRemitter}
                                    ts={ts}
                                />
                            </CardContent>
                            <CardActions>
                                <RemitterCardButtons />
                            </CardActions>
                        </CardActionArea>
                        :
                        <>
                            <CardHeader title="Remitter Information" subheader="Information related to plaintiff" />
                            <CardContent width="auto">
                                <RemitterCardGrid
                                    handleFieldChange={handleFieldChange}
                                    state={state}
                                    updateRemitter={updateRemitter}
                                    ts={ts}
                                />
                            </CardContent>
                            <CardActions>
                                <RemitterCardButtons />
                            </CardActions>
                        </>
                }
            </Card>
        </Stack>
    );
}